




































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { Employee } from '@/model/companyStructure/Employee'
import BooleanCellRenderer from '@/components/cell-renderer/BooleanCellRenderer.vue'
import EmployeeSelectorDialog from '@/components/absences/absence/AbsencesEditorEmployeeSelectorDialog.vue'
import {
  ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE,
  ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM,
  ABSENCES_ASSISTANT_GET_END_DATE, ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE,
  ABSENCES_ASSISTANT_GET_PERIODICITY,
  ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST, ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE,
  ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST,
  ABSENCES_ASSISTANT_GET_START_DATE, GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import {
  ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE,
  ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE,
  ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST,
  CREATE_NEW_PERIODICITY_ABSENCE
} from '@/store/action-types'
import { SelectedEmployee } from '@/model/absences/SelectedEmployee'
import { Absence } from '@/model/absences/Absence'
import { AbsenceSerie, AbwesenheitenInput, CreateAbsenceSeriesResponse } from '@/types/service-response'
import {
  PeriodicityAbsenceDetails,
  PeriodicityAbsencePayload,
  PlanningAssistantPeriodicityPayload
} from '@/types/payload'
import moment from 'moment'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { PeriodicityPlannedAbsenceEmployee } from '@/types'

interface ComponentData {
  gridOptions: GridOptions
  selectedEmployeeList: Array<Employee>
  gridFrameworkComponents: Object
  showEmployeeSelector: boolean
  currentSelectedRowData: any
  overlayNoRowsTemplate: string
  selectedItem: PeriodicityPlannedAbsenceEmployee | undefined
  loading: boolean
  panel: number[]
  isExpansionPanelReadonly: boolean
  periodicitySelectedRow: string | undefined
}

export default Vue.extend({
  name: 'AbsencesEditorEmployeeSelect',

  components: {
    AgGridVue,
    EmployeeSelectorDialog
  },

  props: {
    editAbsence: Object as () => Absence | undefined,
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('absencesPage.name').toString(), field: 'name' },
          { headerName: this.$t('absencesPage.capacity').toString(), field: 'capacity' },
          {
            headerName: this.$t('absencesPage.jumper').toString(),
            field: 'isFloater',
            cellRenderer: 'booleanRenderer'
          },
          { headerName: this.$t('absencesPage.planningGroup').toString(), field: 'planningGroupName' },
        ],
      },

      selectedEmployeeList: [],

      gridFrameworkComponents: {
        booleanRenderer: BooleanCellRenderer
      },

      showEmployeeSelector: false,
      currentSelectedRowData: undefined,
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      selectedItem: undefined,
      loading: false,
      panel: [0],
      isExpansionPanelReadonly: false,
      periodicitySelectedRow: undefined,
    }
  },

  computed: {
    dateStart (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]
    },

    plannedEmployeeList (): SelectedEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
    },

    periodicityPlannedEmployeeList (): PeriodicityPlannedAbsenceEmployee[] {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_PLANNED_EMPLOYEE_LIST]
    },

    isRemoveButtonDisabled (): boolean {
      return !this.currentSelectedRowData
    },

    periodicity (): PlanningAssistantPeriodicityPayload {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY]
    },

    isEditingSerie (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    serieData (): AbsenceSerie | undefined {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_PERIODICITY_SERIE]
    },

    selectedLanguage (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    formattedDate (date: string): string {
      return moment(date, 'DD.MM.YYYY').locale(this.selectedLanguage).format('DD.MM.YYYY - dddd')
    },

    floaterIconColor (employee: SelectedEmployee): string {
      return employee.isFloater ? 'green' : 'red'
    },

    floaterIcon (employee: SelectedEmployee): string {
      return employee.isFloater ? 'check' : 'clear'
    },

    onAddEmployeeButtonClick (item?: PeriodicityPlannedAbsenceEmployee): void {
      this.isExpansionPanelReadonly = true
      this.showEmployeeSelector = true
      if (item && item.date) {
        this.selectedItem = item
        this.periodicitySelectedRow = _.findIndex(this.periodicityPlannedEmployeeList, { date: item.date }).toString()
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowData = params.node.data
    },

    onRemoveEmployeeButtonClick (): void {
      let plannedEmployeeList: SelectedEmployee[] = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
      this.plannedEmployeeList.splice(
        _.findIndex(this.plannedEmployeeList, { id: this.currentSelectedRowData.id }), 1)
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, plannedEmployeeList)
      this.currentSelectedRowData = undefined
    },

    onCloseEmployeeSelector (): void {
      this.loading = false
      this.isExpansionPanelReadonly = false
      this.showEmployeeSelector = false
      this.periodicitySelectedRow = undefined
    },

    onAddEmployeeListToSelection (employeeList: EmployeeAvailableForPlanning[]): void {
      if (!this.isEditingSerie) {
        const selectedEmployeeList: SelectedEmployee[] = employeeList
            .map((item: EmployeeAvailableForPlanning): SelectedEmployee => {
              return new SelectedEmployee(
                  item.id,
                  item.name,
                  item.capacity,
                  item.isFloater,
                  item.planingGroupName,
                  false,
                  undefined,
                  '',
                  this.dateStart,
                  this.dateEnd,
                  undefined
              )
            })

        const newEmployeeList: SelectedEmployee[] = ([] as SelectedEmployee[]).concat(this.plannedEmployeeList, selectedEmployeeList)

        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PLANNED_EMPLOYEE_LIST, newEmployeeList)

        if (!this.periodicity.isUnique) {
          this.createAbsence()
        } else {
          this.onCloseEmployeeSelector()
        }
      } else {
        // Add employees serie

        let localPlannedEmployeeList: PeriodicityPlannedAbsenceEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
        const index: number = this.periodicityPlannedEmployeeList.indexOf(this.selectedItem!)

        const hourStart = parseInt(moment(this.dateStart).format('HH'))
        const hourEnd = parseInt(moment(this.dateEnd).format('HH'))
        const minuteStart = parseInt(moment(this.dateStart).format('mm'))
        const minuteEnd = parseInt(moment(this.dateEnd).format('mm'))

        let updatedStartDate: Date
        let updatedEndDate: Date
        let employeeWithMaxNumber: SelectedEmployee | undefined

        if (localPlannedEmployeeList[index].employeeList[0]) {
          updatedStartDate = moment(localPlannedEmployeeList[index].employeeList[0].start).hours(hourStart).minutes(minuteStart).toDate()
          updatedEndDate = moment(localPlannedEmployeeList[index].employeeList[0].end).hours(hourEnd).minutes(minuteEnd).toDate()
          employeeWithMaxNumber = _.maxBy(localPlannedEmployeeList[index].employeeList, 'number')
        } else {
          const foundDetail: AbwesenheitenInput | undefined = this.serieData!.Absences.find((item: AbwesenheitenInput) => moment(item.DatumVon, 'DD.MM.YYYY').format('DD.MM.YYYY') === localPlannedEmployeeList[index].date)
          if(foundDetail) {
            updatedStartDate = moment(foundDetail!.DatumVon, 'DD.MM.YYYY').hours(hourStart).minutes(minuteStart).toDate()
            updatedEndDate = moment(foundDetail!.DatumBis, 'DD.MM.YYYY').hours(hourEnd).minutes(minuteEnd).toDate()
          }
        }

        let row: number = 0
        if (employeeWithMaxNumber && employeeWithMaxNumber!.number) {
          row = employeeWithMaxNumber!.number
        }

        const selectedEmployeeList: SelectedEmployee[] = employeeList
            .map((item: EmployeeAvailableForPlanning): SelectedEmployee => {
              row++
              return new SelectedEmployee(
                item.id,
                item.name,
                item.capacity,
                item.isFloater,
                item.planingGroupName,
                false,
                undefined,
                '',
                updatedStartDate,
                updatedEndDate,
                row,
               0)
            })

        selectedEmployeeList.forEach((employee: SelectedEmployee) => {
          localPlannedEmployeeList[index].employeeList.push(employee)
        })

        this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
        this.onCloseEmployeeSelector()
      }
    },

    onPeriodicityRemoveEmployeeButtonClick (idx: number, employee: PlannedEmployee) {
      let localPlannedEmployeeList: PeriodicityPlannedAbsenceEmployee[] = _.cloneDeep(this.periodicityPlannedEmployeeList)
      localPlannedEmployeeList[idx].employeeList.splice(
          _.findIndex(localPlannedEmployeeList[idx].employeeList, { id: employee.id }), 1)
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, localPlannedEmployeeList)
    },

    async createAbsence (): Promise<void> {
      try {
        this.loading = true
        const employeeList: Array<SelectedEmployee> = this.$store.getters[ABSENCES_ASSISTANT_GET_PLANNED_EMPLOYEE_LIST]
        const dateStart: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
        const dateEnd: Date = this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]
        const absenceReason: number = this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_REASON_ITEM].id
        const absenceApproved: boolean = this.$store.getters[ABSENCES_ASSISTANT_GET_ABSENCE_APPROVE]

        const details: Array<PeriodicityAbsenceDetails> = []

        employeeList.forEach((item: SelectedEmployee) => {
          details.push(
              {
                employee: item.id,
                comment: item.comment,
                medicalCertificate: item.medicalCertificate,
                medicalCertificateValid: item.medicalCertificateValid ? moment(item.medicalCertificateValid).format('YYYY-MM-DD').toString() : null
              }
          )
        })

        const newPeriodicityAbsencePayload: PeriodicityAbsencePayload = {
          absenceApproved: absenceApproved,
          dateStart: dateStart ? moment(dateStart).format('YYYY-MM-DD HH:mm').toString() : '',
          dateEnd: dateEnd ? moment(dateEnd).format('YYYY-MM-DD HH:mm').toString() : '',
          reason: absenceReason,
          monday: (this.periodicity.weekDayList.includes(1)) ? 'true' : 'false',
          tuesday: (this.periodicity.weekDayList.includes(2)) ? 'true' : 'false',
          wednesday: (this.periodicity.weekDayList.includes(3)) ? 'true' : 'false',
          thursday: (this.periodicity.weekDayList.includes(4)) ? 'true' : 'false',
          friday: (this.periodicity.weekDayList.includes(5)) ? 'true' : 'false',
          saturday: (this.periodicity.weekDayList.includes(6)) ? 'true' : 'false',
          sunday: (this.periodicity.weekDayList.includes(7)) ? 'true' : 'false',
          whlg: this.periodicity.repeatEveryNthWeek.toString(),
          unique: this.periodicity.isUnique ? 'true' : 'false',
          endAfterTimes: this.periodicity.expireAfterRepetitions.toString(),
          endAfterDate: this.periodicity.expireAfterDate ? moment(this.periodicity.expireAfterDate).format('YYYY-MM-DD').toString() : '',
          repetitionRule: "",
          repetitionRuleUI: "",
          details: details
        }

        const response: CreateAbsenceSeriesResponse = await this.$store.dispatch(CREATE_NEW_PERIODICITY_ABSENCE, newPeriodicityAbsencePayload)
        if(!response.IsError && response.Series) {

          const selectedEmployeeList: SelectedEmployee[] = []
          response.Series.Absences.forEach((item: AbwesenheitenInput, index: number) => {
            const foundEmployee: SelectedEmployee | undefined = employeeList.find((employee: SelectedEmployee) => employee.id ? employee.id.toString() === item.Mitarbeiter : false)
            if(foundEmployee) {
              selectedEmployeeList.push(
                  new SelectedEmployee(
                    foundEmployee.id,
                    foundEmployee.name,
                    foundEmployee.capacity,
                    foundEmployee.isFloater,
                    foundEmployee.planningGroupName,
                    item.Arztzeugnis && item.Arztzeugnis === 'true' ? true : false,
                    item.Arztzeugnis_GueltigBis ? new Date(item.Arztzeugnis_GueltigBis) : undefined,
                    item.Bemerkung ? item.Bemerkung : '',
                    moment(item.DatumVon, 'DD.MM.YYYY').toDate(),
                    moment(item.DatumBis, 'DD.MM.YYYY').toDate(),
                    index,
                    item.ID
                  )
              )
            }
          })

          let data: PeriodicityPlannedAbsenceEmployee[] = []
          selectedEmployeeList.forEach((item: SelectedEmployee) => {
            let foundItem: PeriodicityPlannedAbsenceEmployee | undefined

            if (data.length > 0) {
              foundItem = data.find((i: PeriodicityPlannedAbsenceEmployee) => i.date === moment(item.start).format('DD.MM.YYYY'))
            }

            if (foundItem) {
              foundItem.employeeList.push(item)
            } else {
              data.push({ date: moment(item.start).format('DD.MM.YYYY'), seriesId: response.Series.ID ? response.Series.ID : null, employeeList: [item] })
            }
          })

          data = _.sortBy(data, [function(o) { return moment(o.date, 'DD.MM.YYYY').format('YYYY-MM-DD'); }])

          this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_PLANNED_EMPLOYEE_LIST, data)
          this.$store.dispatch(ABSENCES_ASSISTANT_SET_IS_EDITING_SERIE, true)
          this.$store.dispatch(ABSENCES_ASSISTANT_SET_PERIODICITY_SERIE, response.Series)
        }
      } catch (e) {

      } finally {
        this.loading = false
        this.onCloseEmployeeSelector()
      }
    }
  }
})
